import styles from './Footer.module.scss';
const Footer = () => {

    return <div className={styles.footer}>

        <img src="https://businesssystemscdn.blob.core.windows.net/webassets/DHIlogo_emailsig.png" className={styles.logo} alt="DHIlogo" />
        © {(new Date()).getFullYear()} - DHI Group - <a href="https://www.dhigroup.com/legal-and-compliance/privacy-policy"> Privacy Policy</a>

    </div>
}

export default Footer;